import { aawzDate } from '@utils/dates/aawz-date'

const toDisplayDate = (value) => {
  if (!value || typeof value !== 'string') return null
  const date = aawzDate(value, 'YYYY-MM-DD HH:mm')
  return date.isValid() ? date.format('DD/MM/YYYY HH:mm') : null
}

export const extractClientWalletDates = (walletAnalysis) => {
  const wa = walletAnalysis || {}
  return {
    data_atualizacao: toDisplayDate(wa.data_atualizacao_dados),
    data_cotizacao: toDisplayDate(wa.data_cotizacao),
  }
}
